import { useQuery } from "@tanstack/react-query";

import { getMatchStandings } from "../api";
import { TOURNAMENT_ID } from "../config/tournament";
import { useAppStore } from "../stores";
import { pollIntervalMs } from "../utils/refreshCadence";

export const useMatchStanding = () => {
  const matchData = useAppStore((state) => state.matchData);
  const matchId = matchData?.id ?? "";
  const kickoffTime = matchData?.matchDateTime;

  const { error, data, isLoading, refetch } = useQuery({
    queryKey: [`match-standing-${TOURNAMENT_ID}`],
    queryFn: () => getMatchStandings(TOURNAMENT_ID, matchId),
    refetchOnWindowFocus: false,
    staleTime: 0,
    refetchInterval: () => pollIntervalMs("standings", kickoffTime),
    gcTime: 60 * 10 * 1000,
  });

  return {
    error: error ?? !data?.standings,
    data,
    isLoading,
    refetch,
  };
};
